var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2647",
    "data-name": "Group 2647",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 1020,
    viewBox: "0 0 1440 1020",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M393.009,311.79c-35.26,46.64-6.3,101.979-6.3,101.979s60.068,17.1,98.566-26.9S551.1,211.738,551.1,211.738,428.27,265.153,393.009,311.79",
    transform: "translate(-375.52 -211.738)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3001",
    "data-name": "Rectangle 3001",
    width: 1420,
    height: 960.621,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3000",
    "data-name": "Rectangle 3000",
    width: 146.629,
    height: 120.227,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M447.678,277.091c-53.642,23.224-60.327,72.741-60.327,72.741s39.056,31.162,93.876,10.87S629.074,252.845,629.074,252.845s-127.757,1.02-181.4,24.246",
    transform: "translate(-387.351 -252.845)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3002",
    "data-name": "Rectangle 3002",
    width: 177.214,
    height: 59.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M154.494,297.122c52.415,25.911,101.351-12.892,101.351-12.892s5.565-62.208-44.866-91.791S26.627,160.551,26.627,160.551s75.451,110.66,127.867,136.571",
    transform: "translate(-26.627 -160.551)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3004",
    "data-name": "Rectangle 3004",
    width: 141.545,
    height: 124.534,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M118.258,292.335C151.11,340.68,201,337.981,201,337.981s23.3-44.195-6.887-94.248S60.5,118.675,60.5,118.675,85.4,243.987,118.258,292.335",
    transform: "translate(-60.497 -118.675)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3006",
    "data-name": "Rectangle 3006",
    width: 82.779,
    height: 166.292,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2640",
    "data-name": "Group 2640",
    transform: "translate(-683 -223)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M194.532,95.913H176.525V77.905H163.748V95.913h-18V108.69h18V126.7h12.777V108.69h18.007Z",
    transform: "translate(967.042 399.483)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M454.352,96.31H441.293V83.251h-9.266V96.31H418.971v9.266h13.056v13.059h9.266V105.576h13.059Z",
    transform: "translate(1480.777 409.534)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M479,68.664H461V50.656H448.22V68.664h-18V81.44h18V99.448H461V81.44h18Z",
    transform: "translate(1501.925 348.247)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M84,110.759H66V92.751H53.22v18.007h-18v12.777h18v18.007H66V123.535H84Z",
    transform: "translate(759.22 427.397)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M483.8,233.776H470.741V220.717h-9.266v13.059H448.419v9.266h13.056V256.1h9.266V243.042H483.8Z",
    transform: "translate(1536.147 668.007)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M1347.637,360.678c0,49.08-298.508,88.868-666.738,88.868S14.163,409.758,14.163,360.678,312.671,271.81,680.9,271.81s666.738,39.788,666.738,88.868",
    transform: "translate(719.631 764.075)",
    fill: "#edf0fc",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M551.093,211.738S428.267,265.15,393.007,311.79s-6.3,101.976-6.3,101.976,60.065,17.106,98.563-26.9,65.82-175.126,65.82-175.126",
    transform: "translate(1399.077 651.124)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    width: 1420,
    height: 960.621,
    transform: "translate(693 253)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2609",
    "data-name": "Group 2609",
    transform: "translate(1774.597 862.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2608",
    "data-name": "Group 2608",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M592.576,344.024l15.188-2.342c2.6-.4,2.195-4.482-.421-4.078q-53.556,8.261-107.108,16.524-5.016.773-10.029,1.55l8.341-10.251,29.2-35.885q53.115-8.2,106.224-16.389,7.6-1.171,15.188-2.345c2.6-.4,2.194-4.479-.421-4.076q-53.551,8.261-107.108,16.524L531.6,304.8q8.079-9.928,16.161-19.862,8.144-10.01,16.291-20.024c2.492-3.062,5.579-6.089,7.682-9.439a4.531,4.531,0,0,1,.349-.429c1.665-2.048-1.512-4.637-3.18-2.587q-9.781,12.019-19.566,24.044-10.46,12.858-20.916,25.709-2.666-51.508-5.328-103.019-.4-7.673-.8-15.346c-.135-2.638-4.214-2.209-4.076.42q2.8,54.113,5.6,108.229.376,7.228.749,14.453-11.121,13.661-22.236,27.328-7.652,9.4-15.306,18.805-2.661-51.508-5.325-103.018-.4-7.673-.8-15.346c-.135-2.638-4.214-2.209-4.079.421q2.8,54.113,5.6,108.232.371,7.224.746,14.45l-37.538,46.136q-2.662-51.512-5.329-103.021-.393-7.669-.792-15.343c-.138-2.641-4.214-2.212-4.078.418q2.8,54.117,5.6,108.232.371,7.224.746,14.45l-37.538,46.136q-2.665-51.512-5.328-103.018-.4-7.673-.792-15.346c-.138-2.641-4.214-2.212-4.079.418q2.8,54.117,5.6,108.232.376,7.224.749,14.45-2.22,2.731-4.438,5.455-8.148,10.01-16.294,20.023c-2.492,3.062-5.576,6.092-7.682,9.441a4.435,4.435,0,0,1-.348.429c-1.665,2.045,1.512,4.634,3.18,2.586q9.786-12.024,19.566-24.047,4.6-5.651,9.2-11.3,53.111-8.2,106.224-16.389,7.591-1.175,15.185-2.345c2.6-.4,2.195-4.482-.418-4.078Q471,447.612,417.447,455.874l-10.026,1.547,33.958-41.735q1.789-2.2,3.58-4.4,53.111-8.191,106.224-16.389l15.185-2.342c2.6-.4,2.195-4.482-.418-4.078Q512.4,396.74,458.842,405l-10.029,1.547q18.768-23.071,37.538-46.136,53.111-8.2,106.224-16.389",
    transform: "translate(-383.725 -267.513)",
    fill: "#eb725f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(693 253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2612",
    "data-name": "Group 2612",
    transform: "translate(1087.658 694.935)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2610",
    "data-name": "Group 2610",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M524.253,241.275c-4.133,5.876-8.505,11.705-13.18,17.449-40.667,49.981-91.394,81.342-133.449,86.8a95.525,95.525,0,0,0,5.13,12.708s60.068,17.106,98.566-26.9c16.933-19.355,31.7-55.563,42.933-90.054",
    transform: "translate(-377.624 -241.274)",
    fill: "#0046a0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M629.074,252.845s-127.757,1.022-181.4,24.246-60.324,72.744-60.324,72.744,39.056,31.162,93.874,10.87,147.85-107.86,147.85-107.86",
    transform: "translate(728.323 475.416)",
    fill: "#b5b055"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(1808.674 981.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M636.482,368.041l13.488,3c2.31.513,4.194-2.6,1.872-3.117q-47.563-10.563-95.127-21.124-4.454-.985-8.906-1.976,6.131-2.463,12.264-4.919l42.936-17.23q47.17,10.473,94.34,20.948,6.74,1.495,13.485,3c2.31.513,4.193-2.6,1.872-3.119q-47.563-10.559-95.124-21.121-4.454-.989-8.906-1.976l23.762-9.537q11.98-4.8,23.961-9.614c3.664-1.469,7.785-2.728,11.294-4.531.158-.081.345-.138.513-.207,2.448-.982,1.3-3.862-1.155-2.88l-28.771,11.544q-15.381,6.174-30.761,12.342,25.771-38.555,51.537-77.113,3.841-5.742,7.679-11.487c1.319-1.976-2.192-2.926-3.508-.956q-27.071,40.508-54.146,81.013-3.612,5.409-7.23,10.818-16.348,6.558-32.7,13.12-11.25,4.515-22.5,9.027,25.767-38.555,51.537-77.11,3.836-5.746,7.676-11.487c1.319-1.979-2.192-2.926-3.508-.959q-27.072,40.508-54.143,81.013-3.616,5.409-7.229,10.818-27.6,11.073-55.2,22.149,25.767-38.56,51.537-77.113L545,277.762c1.322-1.976-2.192-2.926-3.508-.959l-54.144,81.016-7.229,10.815q-27.6,11.077-55.2,22.149,25.771-38.555,51.536-77.113,3.841-5.742,7.679-11.487c1.319-1.976-2.192-2.926-3.508-.956q-27.072,40.5-54.146,81.013-3.612,5.409-7.229,10.818l-6.524,2.618q-11.981,4.8-23.961,9.612c-3.664,1.472-7.786,2.73-11.294,4.534-.158.081-.346.138-.513.2-2.448.982-1.3,3.865,1.155,2.883l28.774-11.544,13.52-5.427q47.17,10.473,94.34,20.948,6.744,1.495,13.485,2.993c2.31.513,4.194-2.6,1.872-3.116q-47.559-10.559-95.124-21.121l-8.906-1.979q24.968-10.015,49.935-20.035,2.631-1.054,5.265-2.111l94.337,20.945,13.488,3c2.31.513,4.194-2.6,1.872-3.116q-47.563-10.564-95.127-21.121l-8.906-1.979q27.6-11.073,55.2-22.149,47.17,10.477,94.34,20.948",
    transform: "translate(-409.445 -301.677)",
    fill: "#ffcf74"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619",
    transform: "translate(1808.674 1036.474)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M564.565,272.015c-6.509,3.021-13.186,5.936-20.058,8.693-59.8,24-117.6,31.231-154.4,22.181a69.244,69.244,0,0,0-2.759,10.9s39.056,31.164,93.874,10.873c24.114-8.926,55.612-30.865,83.34-52.645",
    transform: "translate(-387.351 -272.014)",
    fill: "#0046a0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M26.628,160.55s75.449,110.663,127.864,136.574,101.354-12.895,101.354-12.895,5.565-62.205-44.869-91.788S26.628,160.55,26.628,160.55",
    transform: "translate(743.068 554.877)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3003",
    "data-name": "Rectangle 3003",
    width: 1420,
    height: 960.621,
    transform: "translate(693 253)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623",
    transform: "translate(769.693 715.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2622",
    "data-name": "Group 2622",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M145.626,174.91q-2.571-7.237-5.144-14.476c-.881-2.48-4.813-1.319-3.926,1.175q18.137,51.063,36.274,102.123,1.7,4.779,3.4,9.563-5.815-3.141-11.628-6.273-20.358-10.987-40.715-21.971-17.99-50.639-35.975-101.282-2.575-7.237-5.144-14.479c-.881-2.48-4.813-1.316-3.926,1.175L115.113,232.59l3.4,9.56L95.973,229.992q-11.358-6.131-22.72-12.258c-3.474-1.875-7.025-4.343-10.712-5.784a3.736,3.736,0,0,1-.484-.259c-2.321-1.256-4.274,2.353-1.947,3.606l27.282,14.724,29.168,15.735q-50.1,12.257-100.2,24.511-7.466,1.827-14.926,3.652c-2.569.628-1.385,4.554,1.172,3.923q52.635-12.87,105.274-25.747l14.056-3.436,31.006,16.729q10.667,5.759,21.337,11.515l-100.2,24.508q-7.461,1.827-14.926,3.652c-2.569.625-1.385,4.548,1.175,3.926q52.635-12.875,105.271-25.752,7.029-1.715,14.056-3.439Q205.827,293.925,232,308.042,181.9,320.3,131.8,332.556L116.87,336.2c-2.566.628-1.383,4.554,1.175,3.929q52.635-12.875,105.271-25.75,7.029-1.72,14.059-3.439,26.169,14.123,52.343,28.244l-100.2,24.505q-7.466,1.832-14.928,3.652c-2.566.628-1.383,4.554,1.175,3.929Q228.4,358.4,281.036,345.523q7.025-1.711,14.056-3.433,3.093,1.668,6.187,3.338,11.363,6.131,22.72,12.258c3.474,1.875,7.025,4.338,10.712,5.778a4.668,4.668,0,0,1,.487.262c2.322,1.253,4.271-2.353,1.944-3.606q-13.64-7.366-27.282-14.721-6.411-3.465-12.82-6.918-17.99-50.639-35.974-101.285-2.575-7.232-5.144-14.476c-.881-2.48-4.813-1.316-3.929,1.175q18.137,51.063,36.277,102.126,1.7,4.774,3.4,9.56-23.676-12.771-47.354-25.548-2.493-1.348-4.992-2.693Q221.333,256.7,203.344,206.057q-2.571-7.241-5.141-14.479c-.881-2.483-4.813-1.319-3.929,1.172l36.274,102.126q1.7,4.783,3.4,9.563-26.169-14.123-52.343-28.244-17.986-50.639-35.975-101.285",
    transform: "translate(-76.693 -221.919)",
    fill: "#eb725f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628",
    transform: "translate(693 253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626",
    transform: "translate(164.546 468.991)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M57.129,162.829c6.544,2.961,13.091,6.167,19.609,9.683,56.707,30.6,97,74.559,110.234,114.851a95.642,95.642,0,0,0,11.521-7.417s5.565-62.208-44.866-91.791c-22.184-13.013-60.512-20.744-96.5-25.326",
    transform: "translate(-57.129 -162.829)",
    fill: "#0046a0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M60.5,118.676s24.909,125.312,57.761,173.657S201,337.982,201,337.982s23.3-44.2-6.887-94.248S60.5,118.676,60.5,118.676",
    transform: "translate(113.75 223.142)",
    fill: "#b5b055"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2630",
    "data-name": "Group 2630",
    transform: "translate(867.247 594.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M178.165,166.088q.207-6.9.418-13.808c.072-2.368-3.338-3.635-3.41-1.259q-1.478,48.7-2.952,97.4-.138,4.558-.274,9.119l-7.129-11.126q-12.482-19.476-24.957-38.956,1.46-48.293,2.923-96.593.212-6.9.42-13.808c.072-2.368-3.341-3.635-3.413-1.259q-1.473,48.7-2.949,97.4-.138,4.558-.276,9.119-6.908-10.779-13.814-21.562-6.965-10.866-13.926-21.737c-2.129-3.324-4.139-7.137-6.564-10.245-.112-.141-.2-.314-.3-.467-1.423-2.221-4.038-.55-2.615,1.673q8.364,13.052,16.726,26.1,8.939,13.955,17.878,27.907l-85.394-36.2L35.837,162.4c-2.189-.927-2.465,2.7-.285,3.623q44.859,19.014,89.715,38.031,5.992,2.536,11.979,5.078,9.5,14.832,19.007,29.664,6.537,10.209,13.079,20.415l-85.394-36.2-12.719-5.392c-2.189-.927-2.465,2.7-.285,3.623q44.854,19.014,89.715,38.031,5.988,2.536,11.979,5.078,16.042,25.037,32.086,50.079l-85.394-36.2q-6.364-2.7-12.722-5.395c-2.186-.927-2.463,2.7-.285,3.626q44.859,19.014,89.717,38.031l11.976,5.075q16.046,25.041,32.086,50.082-42.694-18.1-85.394-36.2l-12.719-5.392c-2.189-.927-2.466,2.7-.285,3.626q44.859,19.014,89.715,38.031l11.979,5.075q1.9,2.964,3.793,5.922l13.926,21.737c2.129,3.324,4.139,7.137,6.567,10.248.109.141.2.314.3.464,1.423,2.221,4.038.55,2.615-1.673q-8.364-13.052-16.726-26.1-3.927-6.135-7.86-12.267,1.465-48.3,2.926-96.593.212-6.9.418-13.811c.072-2.365-3.338-3.632-3.41-1.256q-1.478,48.7-2.949,97.4-.138,4.558-.277,9.119L213.679,322.68,210.62,317.9q1.465-48.3,2.926-96.593.207-6.9.418-13.808c.072-2.368-3.341-3.635-3.413-1.259q-1.473,48.7-2.949,97.4-.138,4.558-.277,9.119-16.042-25.041-32.086-50.082,1.465-48.3,2.926-96.593",
    transform: "translate(-110.226 -164.078)",
    fill: "#ffcf74"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635",
    transform: "translate(693 253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    "data-name": "Group 2634",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2633",
    "data-name": "Group 2633",
    transform: "translate(240.557 394.856)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2632",
    "data-name": "Group 2632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2631",
    "data-name": "Group 2631",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M83.519,137.09q6.278,8.745,12.293,18.079c34.759,54.256,52.683,109.683,50.678,147.516a68.77,68.77,0,0,0,11.221.671s23.307-44.195-6.884-94.248c-13.281-22.017-40.727-48.855-67.309-72.018",
    transform: "translate(-83.519 -137.09)",
    fill: "#0046a0"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3007",
    "data-name": "Rectangle 3007",
    width: 863.587,
    height: 569.777,
    rx: 5.51,
    transform: "translate(275.736 299.449)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3008",
    "data-name": "Rectangle 3008",
    width: 780.708,
    height: 496.227,
    transform: "translate(317.175 343.875)",
    fill: "#d0dbf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M76.253,283.673v45.842a17.987,17.987,0,0,0,17.932,17.935H1034.12a17.987,17.987,0,0,0,17.935-17.935V283.673Z",
    transform: "translate(143.376 533.381)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M208.762,282.968v32.7a5.326,5.326,0,0,0,5.311,5.311H415.931a5.326,5.326,0,0,0,5.311-5.311v-32.7Z",
    transform: "translate(392.528 532.055)",
    fill: "#92a6f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3009",
    "data-name": "Rectangle 3009",
    width: 677.303,
    height: 391.595,
    transform: "translate(361.741 386.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3010",
    "data-name": "Rectangle 3010",
    width: 677.303,
    height: 37.734,
    transform: "translate(361.741 386.14)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M148.3,146.554a8.635,8.635,0,1,1-8.635-8.635,8.634,8.634,0,0,1,8.635,8.635",
    transform: "translate(246.366 259.324)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M158.393,146.554a8.635,8.635,0,1,1-8.635-8.635,8.634,8.634,0,0,1,8.635,8.635",
    transform: "translate(265.349 259.324)",
    fill: "#f9ab43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M168.487,146.554a8.635,8.635,0,1,1-8.635-8.635,8.634,8.634,0,0,1,8.635,8.635",
    transform: "translate(284.328 259.324)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M250.81,264.19q0-16.279,12.924-25.372l4.147-2.872a46.748,46.748,0,0,0,8.217-6.3,8.652,8.652,0,0,0,2.316-6.144q0-9.25-15.479-9.254a61.135,61.135,0,0,0-14.839,1.915,68.172,68.172,0,0,0-14.519,5.424V197.016a78.212,78.212,0,0,1,32.87-6.7q19.623,0,31.112,8.217t11.487,22.737q0,8.135-3.667,13.163t-12.446,11.247q-5.906,4.312-8.618,6.625a15.479,15.479,0,0,0-4.067,5.184,16.324,16.324,0,0,0-1.357,7.019v3.033H250.81Zm3.272,38.212a15.123,15.123,0,0,1,0-20.983,14.531,14.531,0,0,1,10.608-4.148A14.736,14.736,0,0,1,275.3,281.5a14.643,14.643,0,0,1,0,20.9,14.748,14.748,0,0,1-10.614,4.228,14.391,14.391,0,0,1-10.608-4.228",
    transform: "translate(439.187 357.841)",
    fill: "#d0dbf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M334.388,433.75c-74.956,0-135.937-60.981-135.937-135.94s60.981-135.934,135.937-135.934S470.322,222.857,470.322,297.81,409.344,433.75,334.388,433.75m0-263.516A127.579,127.579,0,1,0,461.964,297.81,127.722,127.722,0,0,0,334.388,170.234",
    transform: "translate(373.141 304.37)",
    fill: "#d0dbf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3011",
    "data-name": "Rectangle 3011",
    width: 435.64,
    height: 110.012,
    rx: 5.154,
    transform: "translate(881.589 470.699)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3012",
    "data-name": "Rectangle 3012",
    width: 5.936,
    height: 80.607,
    transform: "translate(1009.101 485.403)",
    fill: "#f5de6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M378.437,212.112l-20.263-10.274a20.05,20.05,0,1,0-2.457,4.845l20.263,10.274ZM332.692,208.3a14.574,14.574,0,0,1,13.183-26v0A14.573,14.573,0,0,1,332.692,208.3",
    transform: "translate(600.307 329.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M323.207,183.569l2.906,1.475a5.93,5.93,0,0,1,7.961-2.6l1.475-2.906a9.191,9.191,0,0,0-12.342,4.035",
    transform: "translate(607.715 335.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3013",
    "data-name": "Rectangle 3013",
    width: 399.761,
    height: 254.31,
    transform: "translate(112.676 591.091)",
    fill: "#f5f9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3014",
    "data-name": "Rectangle 3014",
    width: 399.761,
    height: 31.717,
    transform: "translate(112.676 591.094)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M58.2,215.72a7.258,7.258,0,1,1-7.258-7.258A7.257,7.257,0,0,1,58.2,215.72",
    transform: "translate(82.145 391.964)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M66.691,215.72a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(98.101 391.964)",
    fill: "#f9ab43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M75.176,215.72a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(114.055 391.964)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M59.567,295.337a145.1,145.1,0,0,1,17.624-17.7,196.118,196.118,0,0,1,17.621-13.517,188.03,188.03,0,0,1,105.74-32.616,186.117,186.117,0,0,1,105.74,32.458,196.147,196.147,0,0,1,17.624,13.578,144.469,144.469,0,0,1,17.624,17.794,144.673,144.673,0,0,1-17.624,17.794,196.135,196.135,0,0,1-17.624,13.578,188.067,188.067,0,0,1-211.481-.159,196.083,196.083,0,0,1-17.621-13.517,145.1,145.1,0,0,1-17.624-17.7",
    transform: "translate(112.002 435.295)",
    fill: "#d0dbf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M175.887,290.317a33.538,33.538,0,0,0,16.34-4.234c0,.222.032.438.032.662a51.1,51.1,0,1,1-43.475-50.1,33.655,33.655,0,0,0,27.1,53.671",
    transform: "translate(170.963 443.886)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M59.567,299.018C67.779,288.557,77.609,279.389,88.036,271a206.475,206.475,0,0,1,33.878-21.815A182.008,182.008,0,0,1,159.9,234.742a173.96,173.96,0,0,1,40.569-5.193c3.422.1,6.852.006,10.262.314l10.222.942c6.743,1.106,13.546,1.979,20.11,3.891,6.671,1.515,13.025,4.012,19.465,6.172l9.358,4.009,4.629,2.094,4.473,2.4a219.645,219.645,0,0,1,62.557,49.644c-20.974-16.227-43.02-30.646-66.661-41.09l-4.41-1.982-4.536-1.665-9.021-3.393c-6.172-1.757-12.232-3.868-18.532-5a189.279,189.279,0,0,0-18.831-3.289l-9.522-.737c-3.171-.253-6.36-.081-9.539-.167-25.464-.075-50.822,5.907-74.561,16.049A257.949,257.949,0,0,0,91.46,275.855a261.179,261.179,0,0,0-31.893,23.163",
    transform: "translate(112.002 431.613)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3015",
    "data-name": "Rectangle 3015",
    width: 232.382,
    height: 8.293,
    transform: "translate(224.494 808.208) rotate(-45)",
    fill: "#f5de6c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3016",
    "data-name": "Rectangle 3016",
    width: 399.764,
    height: 254.31,
    transform: "translate(543.273 44.543)",
    fill: "#f5f9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3017",
    "data-name": "Rectangle 3017",
    width: 399.764,
    height: 31.717,
    transform: "translate(543.273 44.546)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M207.7,25.964a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(363.245 35.172)",
    fill: "#c1d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M216.192,25.964a7.26,7.26,0,1,1-7.261-7.258,7.26,7.26,0,0,1,7.261,7.258",
    transform: "translate(379.199 35.172)",
    fill: "#c1d1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M224.676,25.964a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(395.155 35.172)",
    fill: "#c1d1f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3018",
    "data-name": "Rectangle 3018",
    width: 399.764,
    height: 254.31,
    transform: "translate(507.647 103.92)",
    fill: "#f5f9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3019",
    "data-name": "Rectangle 3019",
    width: 399.764,
    height: 31.717,
    transform: "translate(507.647 103.92)",
    fill: "#e2e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M195.336,46.578a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(339.988 73.932)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M203.822,46.578a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(355.944 73.932)",
    fill: "#f9ab43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M212.308,46.578a7.258,7.258,0,1,1-7.258-7.258,7.257,7.257,0,0,1,7.258,7.258",
    transform: "translate(371.9 73.932)",
    fill: "#6e7fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M377.422,206.209H233.472c-8.117,0-14.528-3.243-17.593-8.9s-2.273-12.8,2.163-19.592v0L288.157,70.3c4.294-6.579,10.6-10.349,17.29-10.349s12.993,3.77,17.285,10.346L392.849,177.72c4.436,6.795,5.222,13.938,2.16,19.592s-9.47,8.9-17.587,8.9M230.79,186.038c-1.573,2.411-1.593,3.808-1.512,4.05.133.153,1.313.9,4.194.9h143.95c2.874,0,4.058-.746,4.216-.945.055-.2.035-1.593-1.538-4L309.986,78.616c-1.408-2.157-3.1-3.445-4.539-3.445s-3.134,1.287-4.542,3.445Z",
    transform: "translate(402.453 112.72)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M246.588,147.277a6.05,6.05,0,0,1,4.306-10.357,6.034,6.034,0,0,1,4.361,1.743,6.067,6.067,0,0,1,0,8.615,6.034,6.034,0,0,1-4.361,1.743,5.858,5.858,0,0,1-4.306-1.743M243,75.8h16l-2.972,51.171H245.971Z",
    transform: "translate(456.903 142.524)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M495.323,47.9a87.938,87.938,0,0,0-149.031,66.416,88.64,88.64,0,0,0,13.327,43.3q-4.437,17.282-8.871,34.56a7.5,7.5,0,0,0,9.13,9.13q19.372-4.917,38.745-9.839c20.265,8.69,43.316,10.139,64.279,2.756a89.358,89.358,0,0,0,45.514-35.98C530.629,123.6,524.863,76.421,495.323,47.9m9.8,80.869A74.116,74.116,0,0,1,464.452,177.7a73.63,73.63,0,0,1-54.5,2.414c-4.6-1.581-8.73-4.5-13.69-3.353-9.387,2.16-18.716,4.617-28.042,7.06q1.525-5.941,3.047-11.878c1.068-4.159,2.224-8.307,3.206-12.483.55-2.353.737-4.508-.472-6.8-2.258-4.289-5.1-8.142-7.039-12.633-12.993-29.989-3.724-65.206,21.236-85.806C401.061,43.6,417.6,38.1,434.172,38a73.037,73.037,0,0,1,70.953,90.769",
    transform: "translate(651 43.539)",
    fill: "#f5de6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M408.843,36.608a49.2,49.2,0,1,0,49.2,49.2,49.252,49.252,0,0,0-49.2-49.2m-34.7,49.2a34.745,34.745,0,0,1,34.7-34.7,34.229,34.229,0,0,1,18.86,5.593l-47.971,47.974a34.234,34.234,0,0,1-5.593-18.863m34.7,34.7a34.232,34.232,0,0,1-18.863-5.593l47.974-47.974a34.239,34.239,0,0,1,5.593,18.863,34.743,34.743,0,0,1-34.7,34.7",
    transform: "translate(676.228 68.833)",
    fill: "#cfd6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M537.961,149.307a65.622,65.622,0,0,0-7.984-8.068,88.718,88.718,0,0,0-7.941-6.121A83.646,83.646,0,0,0,474.5,120.533a83.737,83.737,0,0,0-31.663,6.178,85.156,85.156,0,0,0-15.873,8.5,88,88,0,0,0-7.883,6.046,66.189,66.189,0,0,0-8,8.045l-1.84,2.224,1.84,2.221a66.339,66.339,0,0,0,7.984,8.027A88.491,88.491,0,0,0,427,167.862a85.228,85.228,0,0,0,15.83,8.471,83.838,83.838,0,0,0,31.686,6.181h.086A83.666,83.666,0,0,0,522.079,167.9a88.809,88.809,0,0,0,7.878-6.072,66.18,66.18,0,0,0,8-8.088l1.823-2.215Zm-12.587,7.362a82.415,82.415,0,0,1-7.247,5.556,77.885,77.885,0,0,1-14.542,7.751,76.306,76.306,0,0,1-29.053,5.568,77.242,77.242,0,0,1-29.091-5.645,78.048,78.048,0,0,1-14.5-7.722,80.763,80.763,0,0,1-7.307-5.573,63.9,63.9,0,0,1-5.231-4.96,64.4,64.4,0,0,1,5.251-4.977,80.747,80.747,0,0,1,7.253-5.53,78.2,78.2,0,0,1,14.545-7.748,77.322,77.322,0,0,1,29.154-5.642,76.3,76.3,0,0,1,28.99,5.568,77.449,77.449,0,0,1,14.491,7.722,81.773,81.773,0,0,1,7.31,5.6,62.667,62.667,0,0,1,5.251,5,63.379,63.379,0,0,1-5.271,5.026",
    transform: "translate(769.472 226.634)",
    fill: "#f5de6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M464.138,139.771l-3.517,1.953a8.98,8.98,0,0,1-11.587-13.189l2.4-3.246-3.995-.567a19.047,19.047,0,0,0-2.774-.216,19.548,19.548,0,1,0,19.551,19.548c0-.1-.006-.2-.011-.262Z",
    transform: "translate(799.326 234.104)",
    fill: "#f5de6c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3020",
    "data-name": "Rectangle 3020",
    width: 111.141,
    height: 5.235,
    transform: "translate(1202.838 415.601) rotate(-45)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M297.982,420.737c-2.543,3.894-2.575,6.152-2.443,6.547.213.245,2.123,1.455,6.774,1.455H534.976c4.649,0,6.558-1.21,6.815-1.532.089-.314.055-2.575-2.486-6.469L425.981,247.114c-2.275-3.488-5.017-5.57-7.336-5.57s-5.063,2.082-7.339,5.573Z",
    transform: "translate(555.614 454.167)",
    fill: "#f5de6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M551.026,469.4H318.364c-13.12,0-23.48-5.242-28.428-14.381s-3.678-20.68,3.491-31.666v0l113.327-173.62C413.692,239.1,423.877,233,434.7,233s21,6.1,27.939,16.723L575.961,423.351c7.169,10.985,8.442,22.527,3.491,31.666S564.143,469.4,551.026,469.4M314.032,436.8c-2.543,3.894-2.575,6.152-2.443,6.547.213.245,2.123,1.455,6.774,1.455H551.026c4.649,0,6.558-1.21,6.815-1.532.089-.314.055-2.575-2.486-6.469L442.031,263.174c-2.275-3.488-5.017-5.57-7.336-5.57s-5.064,2.082-7.339,5.573Z",
    transform: "translate(539.563 438.108)",
    fill: "#eb725f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M339.562,374.148a9.782,9.782,0,0,1,6.962-16.743,9.751,9.751,0,0,1,7.048,2.82,9.8,9.8,0,0,1,0,13.923,9.749,9.749,0,0,1-7.048,2.817,9.468,9.468,0,0,1-6.962-2.817m-5.8-115.525H359.62l-4.8,82.707H338.568Z",
    transform: "translate(627.565 486.28)",
    fill: "#eb725f"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "NO_DATA",
    "data-name": "NO DATA",
    transform: "translate(1745.749 784.023)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "0.1em"
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.099em"
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.1em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.085em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.023em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.024em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3022",
    "data-name": "Rectangle 3022",
    width: 1420,
    height: 960.621,
    transform: "translate(693 253)",
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3023",
    "data-name": "Rectangle 3023",
    width: 1440,
    height: 1020,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.efb5e50262a96eb8520d311755d8f380.svg";
export { ForwardRef as ReactComponent };